import React from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import Button from '../../../designSystem/Button'
import {TshirtSizesType} from '../../../../../types/Sizes'

type PropsType = {
  /** Specify button sizes */
  size: TshirtSizesType
  /** Callback for Login click */
  onLogInClick: () => void
  /** Callback for Signup click */
  onSignUpClick: () => void
}

const AuthenticationButton = styled(Button)(
  ({theme}) => css`
    margin-bottom: ${theme.layout.spacing.s600}px;
  `
)

const AuthenticationButtons = ({
  size,
  onLogInClick,
  onSignUpClick
}: PropsType) => (
  <>
    <AuthenticationButton
      fullWidth
      size={size}
      dataId="LogInButton"
      onClick={onLogInClick}
    >
      <FormattedMessageWrapper
        id="userWidget.signIn"
        defaultMessage="Sign in"
      />
    </AuthenticationButton>
    <AuthenticationButton
      fullWidth
      appearance="link"
      dataId="SignUpButton"
      size={size}
      onClick={onSignUpClick}
    >
      <FormattedMessageWrapper
        id="userWidget.createAccount"
        defaultMessage="Create an account"
      />
    </AuthenticationButton>
  </>
)

export default AuthenticationButtons
